if (!window.__mkmdLpInit) { window.__mkmdLpInit = true;
/* MKMD Health — Malai landing page behaviour. No dependencies. */
function mkmdLpInit() {
  'use strict';
  var root = document;

  /* ---------- Variant selector + live price ---------- */
  var form = document.querySelector('.mkmd-lp-buy-form');
  if (form) {
    var variants = [];
    try { var vs = form.querySelector('[data-mkmd-variants]'); variants = JSON.parse(vs ? vs.textContent : '[]'); } catch (e) { variants = []; }
    var idInput = document.getElementById('mkmd-lp-variant-id');
    var priceEl = document.getElementById('mkmd-lp-price');
    var perEl = document.getElementById('mkmd-lp-per');
    var btnPrice = document.getElementById('mkmd-lp-btn-price');
    var addBtn = document.getElementById('mkmd-lp-add');
    var dockPrice = document.getElementById('mkmd-lp-dock-price');
    var dockVariant = document.getElementById('mkmd-lp-dock-variant');
        var host = form.closest('product-form') || form;
    var cur = host.getAttribute('data-currency') || '$';
    var money = function (cents) { return cur + (cents / 100).toFixed(2); };
    var ounces = function (size) { var n = parseFloat(size); return isNaN(n) ? 0 : n; };

    function selected(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el : null;
    }
    function sync() {
      var groups = form.querySelectorAll('[data-option-index]');
      var chosen = [], size = '', scent = '';
      for (var g = 0; g < groups.length; g++) {
        var el = groups[g].querySelector('input:checked');
        if (!el) return;
        chosen.push(el.value);
        var hint = groups[g].querySelector('[data-option-hint]');
        if (hint) hint.textContent = el.getAttribute('data-hint') || '';
        if (g === 0) size = el.value; else scent += (scent ? ' · ' : '') + el.value;
      }
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < chosen.length; k++) { if (variants[i].options[k] !== chosen[k]) { ok = false; break; } }
        if (ok) { v = variants[i]; break; }
      }
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.querySelector('span').textContent = form.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      var planEl = selected('mkmd_plan'), planInput = document.getElementById('mkmd-lp-selling-plan');
      var planId = planEl && planEl.value ? planEl.value : '';
      var planPrice = planId && v.plans && v.plans[planId] != null ? v.plans[planId] : null;
      if (planInput) { if (planId && planPrice != null) { planInput.value = planId; planInput.disabled = false; } else { planInput.value = ''; planInput.disabled = true; } }
      var planRadios = form.querySelectorAll('input[name="mkmd_plan"]');
      for (var r = 0; r < planRadios.length; r++) {
        var lbl = planRadios[r].parentNode.querySelector('[data-plan-price]');
        if (!lbl) continue;
        var pid = planRadios[r].value;
        if (!pid) { lbl.textContent = v.price_fmt || money(v.price); continue; }
        var pp = v.plans && v.plans[pid] != null ? v.plans[pid] : null;
        lbl.textContent = pp == null ? '' : money(pp) + (pp < v.price ? ' · save ' + Math.round((1 - pp / v.price) * 100) + '%' : '');
      }
      var p = planPrice != null ? money(planPrice) : (v.price_fmt || money(v.price));
      if (priceEl) priceEl.textContent = p;
      if (btnPrice) btnPrice.textContent = p;
      if (dockPrice) dockPrice.textContent = p;
      if (dockVariant) dockVariant.textContent = size + (scent ? ' · ' + scent : '');
      var oz = ounces(size);
      if (perEl) perEl.textContent = oz ? money(Math.round(v.price / oz)) + ' / oz' : '';
      if (addBtn) {
        if (v.available) addBtn.removeAttribute('disabled'); else addBtn.setAttribute('disabled', 'disabled');
        addBtn.querySelector('span').textContent = v.available ? (host.getAttribute('data-add') || 'Add to cart') : (host.getAttribute('data-soldout') || 'Sold out');
      }
    }
    form.addEventListener('change', sync);
    sync();
  }

  /* ---------- Scroll reveals (rAF-throttled scroll check; robust in editors and emulators) ---------- */
  var reveals = Array.prototype.slice.call(root.querySelectorAll('.mkmd-lp-reveal'));
  var revealTick = false;
  function revealCheck() {
    revealTick = false;
    var vh = window.innerHeight, next = [];
    for (var i = 0; i < reveals.length; i++) {
      var r = reveals[i].getBoundingClientRect();
      if (r.top < vh * 0.94) reveals[i].classList.add('is-in'); else next.push(reveals[i]);
    }
    reveals = next;
    if (!reveals.length) { window.removeEventListener('scroll', onReveal); window.removeEventListener('resize', onReveal); }
  }
  function onReveal() { if (!revealTick) { revealTick = true; window.requestAnimationFrame(revealCheck); } }
  window.addEventListener('scroll', onReveal, { passive: true });
  window.addEventListener('resize', onReveal);
  revealCheck();

  /* ---------- Sticky dock: show after hero, hide while buy box is on screen ---------- */
  var dock = document.getElementById('mkmd-lp-dock');
  var hero = root.querySelector('.mkmd-lp-hero');
  var buyPanel = document.querySelector('.mkmd-lp-buy-form');
  if (dock && hero && buyPanel) {
    var update = function () {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var r = buyPanel.getBoundingClientRect();
      var panelVisible = r.top < window.innerHeight * 0.9 && r.bottom > window.innerHeight * 0.35;
      dock.classList.toggle('is-visible', heroBottom < 0 && !panelVisible);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Results scroller dots ---------- */
  var pairs = root.querySelector('.mkmd-lp-pairs');
  var dots = root.querySelectorAll('.mkmd-lp-pairs-hint i');
  if (pairs && dots.length) {
    var cards = pairs.querySelectorAll('.mkmd-lp-pair');
    var onScroll = function () {
      var center = pairs.scrollLeft + pairs.clientWidth / 2, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    };
    pairs.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Smooth anchor scroll ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
mkmdLpInit();
document.addEventListener('shopify:section:load', function () { mkmdLpInit(); });

(function () {
  var vids = document.querySelectorAll('.mkmd-lp-pair-video');
  if (!vids.length) return;
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { io.observe(v); });
})();

}